<template>
  <v-card class="mb-2">
    <v-card-title class="font-weight-bold">{{ title }}</v-card-title>
    <v-card-text>
      <v-chart @mouseover="changebarvalue" @mouseout="recoverbarvalue" @touchstart="changebarvalue" @touchend="recoverbarvalue"
        v-if="data?.xAxis?.length"
        autoresize
        :option="option"
        style="height: 300px"
      />
      <p v-else>没有数据！</p>
    </v-card-text>
  </v-card>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: ["title", "data"],
  computed: {
    option() {
      return this.data.option;
    },
  },
  data: () => ({}),
  methods:{
    recoverbarvalue(params){
      let paramsDataIndex = params.dataIndex;
      this.data.option.series[0].data[paramsDataIndex] = this.data.optionBackup.series[0].data[paramsDataIndex];
      this.data.option.series[2].data[paramsDataIndex] = this.data.optionBackup.series[2].data[paramsDataIndex];

      let mychart = echarts.getInstanceByDom(this.$el.querySelector("x-vue-echarts"));
      this.$parent.provinceBar.hover = {seriesIndex:null,dataIndex:null};
      this.data.option.dataZoom = mychart.getOption().dataZoom;
      mychart.setOption(this.data.option);
    },
    changebarvalue(params) {
      let paramsDataIndex = params.dataIndex;
      console.log(params);
      if(params.seriesIndex == 2){
        this.data.option.series[2].data[paramsDataIndex] = this.data.optionBackup.series[2].data[paramsDataIndex];
        this.data.option.series[0].data[paramsDataIndex] = 0;
      }else if(params.seriesIndex == 0){
        this.data.option.series[0].data[paramsDataIndex] = this.data.optionBackup.series[0].data[paramsDataIndex];
        this.data.option.series[2].data[paramsDataIndex] = 0;
      }

      let mychart = echarts.getInstanceByDom(this.$el.querySelector("x-vue-echarts"));
      this.$parent.provinceBar.hover = {seriesIndex:params.seriesIndex,dataIndex:params.dataIndex};
      this.data.option.dataZoom = mychart.getOption().dataZoom;
      mychart.setOption(this.data.option);
    },
  }
};
</script>

<style lang="scss" scoped></style>
